import Backbone from 'backbone';
import Bowser2 from 'bowser';
import Cache from 'root/cache';
import Constants from 'root/constants';
import Util from 'root/module/util';

var Survey_Response = Backbone.Model.extend({
    defaults: {
        id                     : 0,
        account_id             : 0,
        project_id             : 0,
        survey_id              : 0,
        user_identification    : '',
        session_recording_id   : '',
        session_id             : '',
        location               : '',
        user_agent             : '',
        ua_data                : '',
        page_url               : '',
        window_x               : 0,
        window_y               : 0,
        resolution_x           : 0,
        resolution_y           : 0,
        dpi                    : 0,
        create_time            : 0,
        answers                : []
    },

    renderAnswer: function(question, nl2br) {
        if (this.isExpired()) {
            return '<span class="survey-response-expired-mask"></span>';
        }

        var question_type = question.get('question_type');
        var answer = this.get('answers')[question.id] || '';
        var answer_html = '';

        nl2br = typeof nl2br === 'undefined' ? false : nl2br;

        if (answer) {
            switch (question_type) {
                case 'short':
                    answer_html = Util.htmlEntities(answer);
                    break;
                case 'long':
                    answer_html = Util.htmlEntities(answer, nl2br);
                    break;
                case 'nps':
                    var score = '';
                    if (answer >= 9) {
                        score = 'Promoter';
                    } else if (answer >= 7) {
                        score = 'Passive';
                    } else {
                        score = 'Detractor';
                    }

                    answer_html = '<span class="survey-icon-nps">' + Util.htmlEntities(answer) + '</span>' + score;
                    break;
                case 'rating':
                    switch (question.get('question_sub_type')) {
                        case 'heart':
                            answer_html = '<span class="survey-icon-heart"><i class="fa-solid fa-heart"></i></span>' + Util.htmlEntities(answer) + ' (Out of ' + question.get('scale') + ')';
                            break;
                        case 'star':
                            answer_html = '<span class="survey-icon-star"><i class="fa-solid fa-star-sharp"></i></span>' + Util.htmlEntities(answer) + ' (Out of ' + question.get('scale') + ')';
                            break;
                        case 'thumb':
                            if (answer == 1) {
                                answer_html = '👍';
                            } else {
                                answer_html = '👎';
                            }
                            break;
                        case 'number':
                            answer_html = '<span class="survey-icon-nps">' + Util.htmlEntities(answer) + '</span>' + ' (Out of ' + question.get('scale') + ')';
                            break;
                        case 'face':
                            var face = '';
                            switch (answer) {
                                case '1':
                                    face = '<i class="fa-solid fa-face-confounded"></i>';
                                    break;
                                case '2':
                                    face = '<i class="fa-solid fa-face-frown-slight"></i>';
                                    break;
                                case '3':
                                    face = '<i class="fa-solid fa-face-meh"></i>';
                                    break;
                                case '4':
                                    face = '<i class="fa-solid fa-face-smile"></i>';
                                    break;
                                case '5':
                                    face = '<i class="fa-solid fa-face-laugh-squint"></i>';
                                    break;
                            }

                            answer_html = '<span class="survey-icon-emoji">' + face + '</span>' + Util.htmlEntities(answer);
                            break;
                    }
                    break;
                case 'dropdown':
                    answer_html =  Util.htmlEntities(answer);
                    break;
                case 'multiple':
                    try {
                        answer_html = Util.htmlEntities(JSON.parse(answer).join(', '));
                        break;
                    } catch(e) {
                        answer_html = Util.htmlEntities(answer);
                        break;
                    }
                case 'yesno':
                    answer_html =  Util.htmlEntities(answer);
                    break;
                default:
                    answer_html =  Util.htmlEntities(answer);
                    break;
            }

            return answer_html
        } else {
            return '';
        }

    },

    getBowserDetection: function() {
        if (!this._bowser_detection) {
            var user_agent = this.get('user_agent') || 'unknown';
            this._bowser_detection = Bowser2.getParser(user_agent);
        }

        return this._bowser_detection;
    },

    getOs: function() {
        var browser = this.getBowserDetection();
        var os = browser.getOS();

        var os_name = browser.getOSName();
        var os_version = (os.versionName || browser.getOSVersion() || '');

        try {
            var ua_data = JSON.parse(this.get('ua_data'));

            var ua_platform_name    = ua_data.platform ? ua_data.platform.toLowerCase() : null;
            var ua_platform_version = ua_data.platformVersion || null;

            if (ua_platform_version) {

                if (ua_platform_name === 'windows') {
                    if (parseInt(ua_platform_version.split('.')[0], 10) > 13) {
                        // Windows 11
                        os_version = 11;
                    }
                } else if (ua_platform_name === 'macos') {
                    switch (parseInt(ua_platform_version.split('.')[0], 10)) {
                        case 11:
                            os_version = 'Big Sur ' + ua_platform_version;
                            break;
                        case 12:
                            os_version = 'Monterey ' + ua_platform_version;
                            break;
                        case 13:
                            os_version = 'Ventura ' + ua_platform_version;
                            break;
                        case 14:
                            os_version = 'Sonoma ' + ua_platform_version;
                            break;
                    }
                }
            }
        } catch(e) {
        }

        return (os_name ? os_name + ' ' : '') + os_version;
    },

    isTablet: function() {
        var browser = this.getBowserDetection();
        return browser.getPlatformType() === 'tablet';
    },

    isPhone: function() {
        var browser = this.getBowserDetection();
        return browser.getPlatformType() === 'mobile';
    },

    isApple: function() {
        var browser = this.getBowserDetection();
        return browser.getPlatform().vendor === 'Apple';
    },

    isAndroid: function() {
        var browser = this.getBowserDetection();
        return browser.getOSName() === 'Android';
    },

    isWindowsPhone: function() {
        var browser = this.getBowserDetection();
        return browser.getOSName() === 'Windows Phone';
    },

    isWindows: function() {
        var browser = this.getBowserDetection();
        return browser.getOSName() === 'Windows';
    },

    isLinux: function() {
        var browser = this.getBowserDetection();
        return browser.getOSName() === 'Linux';
    },

    getSystem: function() {
        var device  = ''
        var os      = ''
        var os_icon = '';

        if (this.isTablet()) {
            device += ' (Tablet)';
        } else if (this.isPhone()) {
            device += ' (Mobile)';
        }

        os = this.getOs();

        if (this.isAndroid()) {
            os_icon = '<i class="fab fa-android text-android"></i> ';
        } else if (this.isApple()) {
            os_icon = '<i class="fab fa-apple"></i> ';
        } else if (this.isWindowsPhone() || this.isWindows()) {
            os_icon = '<i class="fab fa-windows text-windows"></i> ';
        } else if (this.isLinux()) {
            os_icon = '<i class="fab fa-linux"></i> ';
        } else {
            os_icon = '';
        }

        return os_icon + os + device;
    },

    getBrowser: function() {
        var browser = this.getBowserDetection();
        var browser_version = browser.getBrowserVersion();
        var browser_icon = '';
        var browser_name = '';

        switch (browser.getBrowserName()) {
            case 'Chrome':
                browser_icon = '<img class="margin-right-4" width="14" height="14" src="/image/chrome_logo.png">';
                break;
            case 'Firefox':
                browser_icon = '<img class="margin-right-4" width="14" height="14" src="/image/firefox_logo.png">';
                break;
            case 'Internet Explorer':
                browser_icon = '<img class="margin-right-4" width="14" height="14" src="/image/ie_logo.png">';
                break;
            case 'Microsoft Edge':
                browser_icon = '<img class="margin-right-4" width="14" height="14" src="/image/edge_logo.png">';
                break;
            case 'Safari':
                browser_icon = '<img class="margin-right-4" width="14" height="14" src="/image/safari_logo.png">';
                break;
        }

        if (browser_version) {
            browser_version = browser_version.split('.');

            if (browser_version.length >= 3) {
                browser_version = browser_version[0] + '.' + browser_version[1];
            } else {
                browser_version = browser_version.join('.');
            }

            browser_name = browser.getBrowserName() + ' ' + browser_version;
        } else {
            browser_name = browser.getBrowserName();
        }

        if (browser_icon || browser_name) {
            return '<div class="flex-start">' + browser_icon + browser_name + '</div>';
        } else {
            return '';
        }
    },

    isExpired: function() {
        if (Cache.account.isFreePlan()) {
            if (this.get('days_old') !== undefined) {
                return this.get('days_old') > Constants.FREE_FEEDBACK_EXPIRY ? true : false;
            } else {
                // Fallback to computer clock when the days_old is not set in the backend
                // Should not happen
                var now = Date.now() / 1000;
                var expiry_date = Constants.FREE_FEEDBACK_EXPIRY * 24 * 60 * 60;

                return this.get('create_time') < now - expiry_date ? true : false;
            }
        }

        return false;
    }
});

export default Survey_Response;